import axiosToken from "../../api/axiosClient";
import { buildQueryString } from "../../utils/reportUtils";

class SalesReportService {
  /**
   * Récupère le résumé des ventes
   * @param {Object} params - Paramètres de filtrage
   * @param {string} params.period - today, week, month, year, custom
   * @param {string} params.startDate - Date de début (YYYY-MM-DD)
   * @param {string} params.endDate - Date de fin (YYYY-MM-DD)
   * @param {string} params.groupBy - day, week, month, service
   */
  async getSummary(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/sales/summary${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  /**
   * Récupère la liste détaillée des ventes
   * @param {Object} params - Paramètres de filtrage et pagination
   * @param {number} params.page - Numéro de page
   * @param {number} params.limit - Éléments par page
   * @param {string} params.method - Méthode de paiement
   * @param {string} params.type - appointment, subscription, product
   * @param {number} params.minAmount - Montant minimum
   * @param {number} params.maxAmount - Montant maximum
   * @param {string} params.search - Recherche texte
   */
  async getDetails(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/sales/details${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  /**
   * Récupère le top des ventes
   * @param {Object} params - Paramètres
   * @param {number} params.limit - Nombre de résultats
   * @param {string} params.startDate - Date de début
   * @param {string} params.endDate - Date de fin
   */
  async getTopSelling(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/sales/top-selling${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  /**
   * Récupère les ventes par heure
   * @param {Object} params - Paramètres
   * @param {string} params.startDate - Date de début
   * @param {string} params.endDate - Date de fin
   */
  async getByHour(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/sales/by-hour${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  /**
   * Exporte les données au format CSV/Excel
   * @param {string} format - csv ou excel
   * @param {Object} params - Paramètres de filtrage
   */
  async export(format = "csv", params = {}) {
    try {
      const queryString = buildQueryString({ ...params, format });
      const response = await axiosToken.get(
        `/reports/sales/export${queryString}`,
        {
          responseType: "blob",
        },
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  _handleError(error) {
    return {
      message:
        error.response?.data?.error ||
        "Erreur lors de la récupération des données",
      status: error.response?.status,
      originalError: error,
    };
  }
}

export default new SalesReportService();
